/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { cloneDeep } from 'lodash';
import Types from '../constants/actionTypes';

const initialState = {
  openModals: [],
  modalInfo: {}
};

const modalId = (action) => {
  let id;

  if (action && action.id) return action.id;

  if (action.modalType) {
    id = action.modalType.name;

    if (action.props.id) id = `${action.modalType.name}_${action.props.id}`;
  }

  return id;
};

const modalReducer = (state = initialState, action) => {
  const { modalInfo, openModals } = state;
  const id = modalId(action);

  const openModalsClone = cloneDeep(openModals);
  const modalInfoClone = cloneDeep(modalInfo);

  let idIndex;

  switch (action.type) {
    case Types.OPEN_MODAL:
      openModalsClone.push(id);
      modalInfoClone[id] = modalInfoClone[id] || {};
      modalInfoClone[id].open = true;
      modalInfoClone[id].props = action.props;
      modalInfoClone[id].type = action.modalType;
      modalInfoClone[id].tab =
        action.tab || modalInfoClone[id].tab || 'details';
      window.history.pushState(
        null,
        document.title,
        `${window.location.href.split('?')[0]}?modalName=${
          action.modalType.name
        }&itemId=${action.props.id}`
      );
      return {
        ...state,
        openModals: openModalsClone,
        modalInfo: modalInfoClone
      };
    case Types.UPDATE_MODAL:
      modalInfoClone[id].tab = action.tab;
      return { ...state, modalInfo: modalInfoClone };
    case Types.CLOSE_MODAL:
      modalInfoClone[id].open = false;
      modalInfoClone[id].props = null;
      idIndex = openModalsClone.findIndex((el) => el === id);

      if (idIndex >= 0) {
        openModalsClone.splice(idIndex, 1);
      }

      window.history.pushState(
        null,
        document.title,
        window.location.href.split('?')[0]
      );

      return {
        ...state,
        openModals: openModalsClone,
        modalInfo: modalInfoClone
      };
    case Types.CLOSE_ALL_MODALS:
      return { ...state, ...initialState };
    default:
      return state;
  }
};

export default modalReducer;
